var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ABButton',{attrs:{"loading":_vm.workflowActionsInProgress},on:{"click":function($event){_vm.fireEvent(_vm.elementType.getEventByName(_vm.element, _vm.eventName))}}},[_vm._v("\n  "+_vm._s(_vm.labelWithDefault)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }